import { Form } from 'ant-design-vue';
import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store/index'
import { LoginInfo } from '@/api/user'
// import perssion from '@/perssion'
import i18n from '../lang/i18n'


const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('../views/Layout.vue'),
    children: [
      // {
      //   path: 'devicemgr',
      //   component: () => import('../views/Device/DeviceMgr.vue'),
      //   meta: {
      //     title: '设备管理',
      //     module: '管理'
      //   }
      // },
      // {
      //   path: 'systemmgr',
      //   component: () => import('../views/system/SystemMgr.vue'),
      //   meta: {
      //     title: '角色管理',
      //     module: '权限配置'
      //   }
      // }
    ]
  },
  {
    name:'IntelligencePlatform',
    path: '/IntelligencePlatform',
    component: () => import('../views/HomePage/IntelligencePlatform.vue'),
    // component: () => import('../views/HomePage/Home1.vue'),
    meta: {
      // title: '瑞腾智能数据平台',
      title: i18n.global.t('menu.瑞腾智能数据平台'),
    }
  },
  {
    name:'OnlineProtocolDoc',
    path: '/OnlineProtocolDoc/:routeimei?',
    component: () => import('../views/OnlineProtocolDoc.vue'),
    meta: {
      title: i18n.global.t('menu.在线协议文档'),
    }
  },
  {
    path: '/login',
    // name:'login',
    component: () => import('../views/Login.vue'),
    meta: {
      // title: '登录',
      title: i18n.global.t('menu.登录'),
    }
  },
  {
    path: '/error404',
    // name:'login',
    component: () => import('../views/Error404.vue'),
  },
  {
    path: '/:pathMatch(.*)',
    // name:'login',
    component: () => import('../views/Error404.vue'),
  }

]




const router = createRouter({
  history: createWebHashHistory(),
  routes
})




const finalRoutes = [];
function formatRoutes(myroutes) {
  myroutes.forEach(route => {
    const { Path, Component, Title, Module, Children } = route;
    const routeObject = {
      path: Path,
      component: () => import(`@/views${Component}`),
      // meta: meta || {},
      meta: {
        title: Title,
        module: Module
      },
      children: (Children && Children.length > 0) ? formatRoutes(Children) : []
    };
    if (route.Type == 1||route.Type == 2) {
      finalRoutes.push(routeObject);
    }


  });
  return finalRoutes;
}

function initRoute(resData){
  const syncRoutes=[];
  resData.forEach(item=>{
    if(item.Children.length>0){
      item.Children.forEach((item1)=>{
        syncRoutes.push({
          // path:`/${item1.Path}`,
          path:item1.Path,
          meta:{
            title:item1.Title,
            module:item1.Module,
          },
          component: () => import(`@/views${item1.Component}`),
        })
      })
    }
    else{
      syncRoutes.push({
        // path:`/${item.Path}`,
        path:item.Path,
          meta:{
            title:item.Title,
            module:item.Module,
          },
          component: () => import(`@/views${item.Component}`),
      })
    }
  });
  return syncRoutes;
}


function createMenu(menuList){
  const routeList=[]
  const deepMenu=menuList=>{
    for(const menu of menuList){
      if(menu.Children&&menu.Children.length>0){
        deepMenu(menu.Children)
      }else{
        routeList.push({
          path:menu.Path,
          name:'cache'+menu.Path,
          meta:{
            title:menu.Title,
            module:menu.Module
          },
          component:() => import(`@/views${menu.Component}`),
        })
      }
    }
  }
  deepMenu(menuList);
  for(const route of routeList){
    router.addRoute('layout',route)
  }
}



router.beforeEach((to, from, next) => {
  // console.log(router.getRoutes(),'查看所有路由')

  if(to.meta&&to.meta.title!=null&&to.meta.title!=''){
    const message = i18n.global.t(`menu.${to.meta.title}`);
    // i18n.t(to.meta.title);

    console.log(message);
    document.title = message + '-'+ i18n.global.t('message.BaseTitle');

  }else{
    document.title = i18n.global.t('message.BaseTitle');
  }



  if ((localStorage.getItem('token') === null || localStorage.getItem('token') === "") && to.path !== '/login') {
    next({ path: '/login' })
  }
  else {
    if (store.state.asyncRouteMark == false && localStorage.getItem('token') !== null && localStorage.getItem('token') !== "") {
      LoginInfo().then(function (res) {
        store.commit('SetAsyncRouteMark', true);
        store.commit('SetAsyncMenuJsonList',res.data.actions);
        localStorage.setItem('self',JSON.stringify(res.data.self));
        var lastroute = [];
        //lastroute = formatRoutes(res.data.actions);
        // console.log(lastroute, '服务器获取的动态路由');
        // lastroute.forEach(element => {
        //   router.addRoute('layout', element);
        // });
        createMenu(res.data.actions);
        // router.addRoute('layout', {
        //   path: '/:pathMatch(.*)',
        //   component: () => import('../views/Error404.vue'),
        //   meta: {
        //     title: '404',
        //   }
        // })
        // console.log(router.getRoutes(), '查看所有路由');
        if(to.path=="/"){
          next({ path: '/Home/Console' })
        }
        else{
          next({ ...to, replace: true })
        }
    
        // console.log(res);

      })
    }
    else{
      if(to.path=="/"){
        next({ path: '/Home/Console' })
      }
      else{
        next();
      }
      
    }
    // LoginInfo(localStorage.getItem('token')).then(res=>{
    //   var test= generator(res.data.actions)
    //   console.log(test)
    // })
  
  }
  // if(to.path==="/"&&store.state.asyncRouteMark==true){
  //   next({ path: '/home' })
  // }

})


export default router
